import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { AnimatedSpinner, Text } from '../../../../../components';

const AnimatedSpinnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  justify-self: center;
  align-items: center;
  column-gap: 8px;
  height: 100%;
  margin-top: 30px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

const StyledText = styled(Text)`
  font-weight: 700;
`;

const AssetLoader = ({ title = null, subtitle = null, className = null, size = 40 }) => (
  <AnimatedSpinnerContainer className={className}>
    <AnimatedSpinner size={size} />
    <Container>
      {title && (
        <StyledText $small $color='var(--content-subtitle)'>
          {title}
        </StyledText>
      )}
      {subtitle && (
        <Text $small $color='var(--content-subtitle)'>
          {subtitle}
        </Text>
      )}
    </Container>
  </AnimatedSpinnerContainer>
);

AssetLoader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number
};

export { AssetLoader };
